import React from "react";
import IconClose from "../../../../../src/assets/icons/closeIcon.svg";
import { ReactComponent as CloseIcon } from "../../../../../src/assets/icons/closeIcon.svg";

function CloseModalButton({ color, className }) {
  return (
    <>
      <CloseIcon className={className} stroke={color} />
    </>
  );
}

CloseModalButton.defaultProps = {
  className: "w-8 h-8 text-xl hover:brightness-125",
  color: "#162e5b",
};

export default CloseModalButton;
